import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            My name is <span className="lime">Levente Ilyó-Kovács </span>
            and I'm from <span className="lime">Hungary</span>.
            <br /> I am a second year BSc computer science engineer student.
            <br /> I also work part-time at a Siemens company.
            <br />
            <br />
            Apart from coding, some other activities that I love to do:
          </p>
          <ul>
            <li className="about-activity">
            🎮 Playing Games
            </li>
            <li className="about-activity">
            🚀 Traveling long distances
            </li>
            <li className="about-activity">
            🥾 Hiking
            </li>
            <li className="about-activity">
            🚗 Driving
            </li>
            <li className="about-activity">
            🎵 Listening to music
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Putting you into a virtual world really allows you to think differently!"{" "}
          </p>
          <footer className="blockquote-footer">Lisa Su</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
